import React from 'react'

export const itemTemplate = option =>
  option.hidden ? null : (
    <span className={`p-item-label p-lvl-${option.lvl || 0}`} data-key={option.key}>
      {option.icon ? <i className={`p-item-icon icon-aytmfd-${option.icon}`} /> : null}
      <span dangerouslySetInnerHTML={{ __html: option.text }}></span>
    </span>
  )
export const valueTemplate = (option, _props) =>
  option ? (
    <>
      {option.icon ? <i className={`p-item-icon icon-aytmfd-${option.icon}`} /> : null}
      <span dangerouslySetInnerHTML={{ __html: option.label || option.text.split(':')[0] }}></span>
    </>
  ) : (
    <span dangerouslySetInnerHTML={{ __html: _props.placeholder || 'Select...' }}></span>
  )

export const optionGroupTemplate = option =>
  option.hidden || !option.text.trim().length ? null : (
    <span className="p-item-group-text" dangerouslySetInnerHTML={{ __html: option.text }}></span>
  )
